import PropTypes from "prop-types";
import * as React from "react";
import { Chip } from "../../../themeV2";
import { CATEGORIES } from "../../../domain/influencerService";
import { categoryChipClass } from "./categoryChipClass";
import s from "./ManageServices.module.css";

const categoryLabels = {
  [CATEGORIES.QUOTE]: "Quote",
  [CATEGORIES.DOODLE]: "Doodle",
  [CATEGORIES.CUSTOM]: "Custom",
};

const DragOverlayService = React.memo(function DragOverlayService({ service }) {
  if (!service) return null;

  return (
    <div className={s.dragOverlay}>
      <Chip
        label={categoryLabels[service.category] ?? service.category}
        size="sm"
        className={categoryChipClass(service.category, s)}
      />
      <span>{service.label}</span>
    </div>
  );
});

DragOverlayService.propTypes = {
  service: PropTypes.shape({
    category: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
};

export default DragOverlayService;
